const groupTypeList = [
  {
    groupType: "1:2",
    checked: false,
    studentLimitType: "Not Limited",
    studentLimit: 0,
    studentLimitWait: 0,
    isGroupCode: "",
  },
  {
    groupType: "1:3",
    checked: false,
    studentLimitType: "Not Limited",
    studentLimit: 0,
    studentLimitWait: 0,
    isGroupCode: "",
  },
  {
    groupType: "1:4",
    checked: false,
    studentLimitType: "Not Limited",
    studentLimit: 0,
    studentLimitWait: 0,
    isGroupCode: "",
  },
  {
    groupType: "1:5",
    checked: false,
    studentLimitType: "Not Limited",
    studentLimit: 0,
    studentLimitWait: 0,
    isGroupCode: "",
  },
];
const languageList = [
  {
    lang: "영어(원어민)",
    checked: false,
  },
  {
    lang: "영어(필리핀)",
    checked: false,
  },
  {
    lang: "중국어",
    checked: false,
  },
  {
    lang: "일본어",
    checked: false,
  },
];

/**
 * [2024-12-24] 그룹 수강 레벨 리스트
 * - sortOrder: 레벨 정렬 순서 (1~40: 주니어, 41~47: 성인)
 */
const levelList = [
  {
    levelName: "초등(저학년) 입문1",
    checked: false,
    sortOrder: 1,
  },
  {
    levelName: "초등(저학년) 입문2",
    checked: false,
    sortOrder: 2,
  },
  {
    levelName: "초등(저학년) 초급1",
    checked: false,
    sortOrder: 3,
  },
  {
    levelName: "초등(저학년) 초급2",
    checked: false,
    sortOrder: 4,
  },
  {
    levelName: "초등(저학년) 중급1",
    checked: false,
    sortOrder: 5,
  },
  {
    levelName: "초등(저학년) 중급2",
    checked: false,
    sortOrder: 6,
  },
  {
    levelName: "초등(저학년) 고급1",
    checked: false,
    sortOrder: 7,
  },
  {
    levelName: "초등(저학년) 고급2",
    checked: false,
    sortOrder: 8,
  },
  {
    levelName: "초등(저학년) 고급3",
    checked: false,
    sortOrder: 9,
  },
  {
    levelName: "초등(저학년) 고급4",
    checked: false,
    sortOrder: 10,
  },

  {
    levelName: "초등(고학년) 입문1",
    checked: false,
    sortOrder: 11,
  },
  {
    levelName: "초등(고학년) 입문2",
    checked: false,
    sortOrder: 12,
  },
  {
    levelName: "초등(고학년) 초급1",
    checked: false,
    sortOrder: 13,
  },
  {
    levelName: "초등(고학년) 초급2",
    checked: false,
    sortOrder: 14,
  },
  {
    levelName: "초등(고학년) 중급1",
    checked: false,
    sortOrder: 15,
  },
  {
    levelName: "초등(고학년) 중급2",
    checked: false,
    sortOrder: 16,
  },
  {
    levelName: "초등(고학년) 고급1",
    checked: false,
    sortOrder: 17,
  },
  {
    levelName: "초등(고학년) 고급2",
    checked: false,
    sortOrder: 18,
  },
  {
    levelName: "초등(고학년) 고급3",
    checked: false,
    sortOrder: 19,
  },
  {
    levelName: "초등(고학년) 고급4",
    checked: false,
    sortOrder: 20,
  },

  {
    levelName: "중등 입문1",
    checked: false,
    sortOrder: 21,
  },
  {
    levelName: "중등 입문2",
    checked: false,
    sortOrder: 22,
  },
  {
    levelName: "중등 초급1",
    checked: false,
    sortOrder: 23,
  },
  {
    levelName: "중등 초급2",
    checked: false,
    sortOrder: 24,
  },
  {
    levelName: "중등 중급1",
    checked: false,
    sortOrder: 25,
  },
  {
    levelName: "중등 중급2",
    checked: false,
    sortOrder: 26,
  },
  {
    levelName: "중등 고급1",
    checked: false,
    sortOrder: 27,
  },
  {
    levelName: "중등 고급2",
    checked: false,
    sortOrder: 28,
  },
  {
    levelName: "중등 고급3",
    checked: false,
    sortOrder: 29,
  },
  {
    levelName: "중등 고급4",
    checked: false,
    sortOrder: 30,
  },

  {
    levelName: "고등 입문1",
    checked: false,
    sortOrder: 31,
  },
  {
    levelName: "고등 입문2",
    checked: false,
    sortOrder: 32,
  },
  {
    levelName: "고등 초급1",
    checked: false,
    sortOrder: 33,
  },
  {
    levelName: "고등 초급2",
    checked: false,
    sortOrder: 34,
  },
  {
    levelName: "고등 중급1",
    checked: false,
    sortOrder: 35,
  },
  {
    levelName: "고등 중급2",
    checked: false,
    sortOrder: 36,
  },
  {
    levelName: "고등 고급1",
    checked: false,
    sortOrder: 37,
  },
  {
    levelName: "고등 고급2",
    checked: false,
    sortOrder: 38,
  },
  {
    levelName: "고등 고급3",
    checked: false,
    sortOrder: 39,
  },
  {
    levelName: "고등 고급4",
    checked: false,
    sortOrder: 40,
  },
];
const lecDayList = [
  {
    label: "월",
    checked: false,
  },
  {
    label: "화",
    checked: false,
  },
  {
    label: "수",
    checked: false,
  },
  {
    label: "목",
    checked: false,
  },
  {
    label: "금",
    checked: false,
  },
  {
    label: "토",
    checked: false,
  },
  {
    label: "일",
    checked: false,
  },
];
export { groupTypeList, languageList, levelList, lecDayList };
